module.exports = __webpack_public_path__ + "static/nir-eyal-d02372ea78db14dea4206c08af160eee.jpg";